/**
 * Palantir PMS - Revenue Management Container
 * Autor: Alberto Castro Ull
 * Fecha: 03/11/2025
 * Mantiene las vistas de Revenue Management separadas
 */

import React, { useCallback, useEffect, useState } from "react";
import RevenueManagement from "./RevenueManagement";
import RoomRatesMatrix from "../Components/RoomRatesMatrix";
import { isDemoMode } from "../demo/demoMode";

const normalizeTab = (tab) => {
  if (tab === "management" || tab === "matrix") return tab;
  return "management";
};

export default function RevenueManagementContainer({ forcedTab = null }) {
  const demoModeActive = isDemoMode();
  const [activeTab, setActiveTab] = useState(normalizeTab(forcedTab));
  const [pendingRevenueAction, setPendingRevenueAction] = useState(null);

  useEffect(() => {
    setActiveTab(normalizeTab(forcedTab));
  }, [forcedTab]);

  const openManagementAction = useCallback((action) => {
    if (demoModeActive) return;
    setPendingRevenueAction(action);
    setActiveTab("management");
  }, [demoModeActive]);

  const visibleTab = activeTab;

  return (
    <div
      className="revenue-management-container"
      style={{
        height: "100%",
        minHeight: 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        padding: 0,
      }}
    >
      {!forcedTab && (
        <div className="d-flex mb-3 border-bottom border-secondary pb-1">
          <button
            className={`btn border-0 fw-bold me-3 ${
              visibleTab === "management"
                ? "text-warning border-bottom border-warning"
                : "text-light"
            }`}
            onClick={() => setActiveTab("management")}
          >
            Room Rates Management
          </button>

          <button
            className={`btn border-0 fw-bold ${
              activeTab === "matrix"
                ? "text-warning border-bottom border-warning"
                : "text-light"
            }`}
            onClick={() => setActiveTab("matrix")}
          >
            Room Rates Matrix
          </button>
        </div>
      )}

      <div
        className="revenue-management-content"
        style={{
          flex: "1 1 auto",
          height: "100%",
          minHeight: 0,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          padding: 0,
        }}
      >
        {visibleTab === "management" && (
          <RevenueManagement
            pendingAction={demoModeActive ? null : pendingRevenueAction}
            onPendingActionConsumed={() => setPendingRevenueAction(null)}
          />
        )}
        {visibleTab === "matrix" && (
          <RoomRatesMatrix
            onOpenBulkApply={demoModeActive ? null : () => openManagementAction("bulk_apply")}
            onOpenStopSellsOverview={demoModeActive ? null : () => openManagementAction("stop_sells_overview")}
          />
        )}
      </div>
    </div>
  );
}
